import { requestMagicLink } from "@src/appV2/Auth/cognito/cognitoAuth";
import { mapCognitoError } from "@src/appV2/Auth/cognito/mapCognitoError";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";

interface SendLoginEmailParams {
  email: string;
  requestedURL?: string | undefined;
}

export type SendLoginEmailResult = { success: true } | { success: false; error: string };

/**
 * Sends a Cognito magic link login email.
 *
 * Uses the Cognito magic link flow (requestMagicLink) instead of the legacy
 * Firebase email link. This avoids the window.location.href / oobCode issues
 * that Firebase links have in the Capacitor native environment.
 *
 * The link lands on /v2/email-login-link?payload=...&email=... which is
 * handled by AuthRedirect — no browser-based Firebase redirect required.
 */
export async function sendLoginEmail({
  email,
}: SendLoginEmailParams): Promise<SendLoginEmailResult> {
  try {
    await requestMagicLink(email);
    return { success: true };
  } catch (error: unknown) {
    const mappedError = mapCognitoError(error, "magic-link-request");
    logError(APP_V2_APP_EVENTS.COGNITO_AUTH_REDIRECT_FAILURE, {
      error,
      metadata: { errorCode: mappedError.code, errorMessage: mappedError.message, email },
    });
    return { success: false, error: mappedError.message };
  }
}
